<template>
    <div>
         <!-- HEADER TITULO -->
        <div class="titulo-contenido">
            <h1>
                <span class="negrita">PLAN ESTATAL DE DESARROLLO</span>
            </h1>
        </div>
        <!-- CONTENIDO PRINCIPAL -->
        <div class="container contenido_principal"> <!--el contenedor padre solo sirve para los estilos en ipad´s pro-->
            <!-- ===Apartado de las cards=== -->
            <div class="seccion_cardsOpciones my-4">
                <div class="row px-5 d-flex align-items-center justify-content-between">
                <div class="col-xs-12 col-sm-6 col-md-6">
                    <a target="_blank" :href="urlServe+'planeacion/Informacion/PED/PED-2025.pdf'">
                        <div class="card mb-3 p-1" >
                            <div class="row no-gutters">
                            <!---Imagen de la card-->
                            <div class="col-md-4 p-2 text-center justify-content-center" >
                                <!-- <img src="imagenes/img1.jpg" alt=""> -->
                                <i class='bx bx-pencil icono_card'></i>
                            </div>
                            <!---Texto de la card-->
                            <div class=" col-md-8">
                                <div class="card-body">
                                <h5 class="titulo_subsec card-title mb-4">Plan Estatal de Desarrollo Chiapas 2025-2030</h5>
                                </div>
                            </div>
                            </div>
                        </div>
                        </a>
                </div>  
                <div class="col-xs-12 col-sm-12 col-md-6">
                        <a target="_blank" :href="urlServe+'planeacion/Informacion/PED/Decreto-PED-2025.pdf'">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                <div class="col-md-4 p-2 text-center justify-content-center">
                                <!-- <img src="imagenes/img3.jpg" alt=""> -->
                                <i class='fas fa-file-alt icono_card'></i>
                                </div>
                                <div class="col-md-8">
                                    <div class="card-body  justify-content-center">
                                    <h5 class="titulo_subsec card-title mb-4 text-justify">Decreto No. 244, por el que se aprueba el Plan Estatal de Desarrollo 2025-2023 (PO. No. 039 de fecha 7 de mayo de 2025)</h5>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mounted(){
      window.scrollTo(0, 0);
    },
    methods:{
        alto_contenido(){
            if(screen.width > 1366)  return 'pantalla_grande' 
        }
    }
}
</script>
<style scoped>
.pantalla_grande{  margin-bottom: 14rem !important; }
a:hover{
  color: #fff;
  text-decoration: none;
}
/* MEDIA QUERY SOLO PARA IPAD 10 pro (MODO HORIZONTAL) */
@media only screen and 
(device-width : 1366px) and 
(device-height : 1024px) and 
(orientation : landscape) {
    .contenido_principal{
        padding-top: 5rem; 
        padding-bottom: 5rem;
    }

} 
</style>